/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountCanSelfServiceSignupRemoveWebsiteLimitQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountCanSelfServiceSignupRemoveWebsiteLimitQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly canSelfServiceSignupRemoveWebsiteLimit: boolean, readonly id: CK.AccountId } | null };


export const AccountCanSelfServiceSignupRemoveWebsiteLimitDocument = gql`
    query AccountCanSelfServiceSignupRemoveWebsiteLimit($accountId: AccountId!) {
  account(id: $accountId) {
    canSelfServiceSignupRemoveWebsiteLimit
    id
  }
}
    `;

/**
 * __useAccountCanSelfServiceSignupRemoveWebsiteLimitQuery__
 *
 * To run a query within a React component, call `useAccountCanSelfServiceSignupRemoveWebsiteLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountCanSelfServiceSignupRemoveWebsiteLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountCanSelfServiceSignupRemoveWebsiteLimitQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountCanSelfServiceSignupRemoveWebsiteLimitQuery(baseOptions: Apollo.QueryHookOptions<AccountCanSelfServiceSignupRemoveWebsiteLimitQuery, AccountCanSelfServiceSignupRemoveWebsiteLimitQueryVariables> & ({ variables: AccountCanSelfServiceSignupRemoveWebsiteLimitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountCanSelfServiceSignupRemoveWebsiteLimitQuery, AccountCanSelfServiceSignupRemoveWebsiteLimitQueryVariables>(AccountCanSelfServiceSignupRemoveWebsiteLimitDocument, options);
      }
export function useAccountCanSelfServiceSignupRemoveWebsiteLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountCanSelfServiceSignupRemoveWebsiteLimitQuery, AccountCanSelfServiceSignupRemoveWebsiteLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountCanSelfServiceSignupRemoveWebsiteLimitQuery, AccountCanSelfServiceSignupRemoveWebsiteLimitQueryVariables>(AccountCanSelfServiceSignupRemoveWebsiteLimitDocument, options);
        }
export function useAccountCanSelfServiceSignupRemoveWebsiteLimitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountCanSelfServiceSignupRemoveWebsiteLimitQuery, AccountCanSelfServiceSignupRemoveWebsiteLimitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountCanSelfServiceSignupRemoveWebsiteLimitQuery, AccountCanSelfServiceSignupRemoveWebsiteLimitQueryVariables>(AccountCanSelfServiceSignupRemoveWebsiteLimitDocument, options);
        }
export type AccountCanSelfServiceSignupRemoveWebsiteLimitQueryHookResult = ReturnType<typeof useAccountCanSelfServiceSignupRemoveWebsiteLimitQuery>;
export type AccountCanSelfServiceSignupRemoveWebsiteLimitLazyQueryHookResult = ReturnType<typeof useAccountCanSelfServiceSignupRemoveWebsiteLimitLazyQuery>;
export type AccountCanSelfServiceSignupRemoveWebsiteLimitSuspenseQueryHookResult = ReturnType<typeof useAccountCanSelfServiceSignupRemoveWebsiteLimitSuspenseQuery>;
export type AccountCanSelfServiceSignupRemoveWebsiteLimitQueryResult = Apollo.QueryResult<AccountCanSelfServiceSignupRemoveWebsiteLimitQuery, AccountCanSelfServiceSignupRemoveWebsiteLimitQueryVariables>;